module.exports = __webpack_public_path__ + "static/media/20151009_171240.f8d1e270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20151009_171240.jpg
// module id = 446
// module chunks = 0